import { TOKEN_KEY } from '@/consts/const';
import { clearImpersonatingFlag } from '@/utils/auth/impersonation';

export function saveAuthToken(token: string): void {
  clearImpersonatingFlag();
  localStorage.setItem(TOKEN_KEY, token);
}
